/* eslint-disable camelcase */
import { useRef, useState } from 'react';
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Modal,
  Box,
  Stack,
  Typography,
  Button,
} from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { notification } from 'antd';
// component
import Iconify from '../../components/Iconify';
import instance from '../../api/axiosRequest';
import { saveEmailData } from '../../features/campaign/campaignSlice';

// ----------------------------------------------------------------------
CampaignMoreMenu.propTypes = {
  row: PropTypes.shape({
    amount: PropTypes.string,
    currency: PropTypes.string,
    razorpay_order_id: PropTypes.string,
    template: PropTypes.string,
    campain: PropTypes.string,
  }).isRequired,
  setReload: PropTypes.func.isRequired,
};

export default function CampaignMoreMenu({ row, setReload }) {
  const ref = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);

  const handleEdit = () => {
    dispatch(saveEmailData({ ...row, to: [], edit: true }));
    navigate('/dashboard/campaigns/campaigns/create');
  };

  const handleExecuteCampaign = () => {
    navigate(`/dashboard/campaigns/campaigns/execute?campaignName=${row.campain}&templateName=${row.template}`);
  };

  const handleDelete = () => setOpen(true);

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleExecuteCampaign}>
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Execute" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleEdit}>
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleDelete}>
          <ListItemIcon>
            <Iconify icon="eva:trash-2-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
      </Menu>
      <ConfirmDeleteModal item={row} open={open} setOpen={setOpen} setReload={setReload} />
    </>
  );
}

const openNotification = ({ message, description = '', type }) => {
  notification.open({
    type,
    message,
    description,
    duration: 4,
  });
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  px: 8,
  py: 4,
};

function ConfirmDeleteModal({ open, setOpen, setReload, item }) {
  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setLoading(true);
      await instance.delete(`/vendor/emailCampain/${item.id}`, { id: item.id });
      openNotification({
        message: 'Campaign deleted successfully.',
        type: 'success',
      });
      setLoading(false);
      setReload((state) => state + 1);
      handleClose();
    } catch (error) {
      setLoading(false);
      let description = '';
      if (error.response.data.message) description = error.response.data.message;
      openNotification({
        message: 'Campaign not deleted.',
        description,
        type: 'error',
      });
      console.log(error);
    }
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose} aria-labelledby="device-delete" aria-describedby="delete-device">
        <Box sx={style}>
          <Stack spacing={2} alignItems="center">
            <CancelOutlinedIcon sx={{ fontSize: '5em' }} />
            <Typography variant="h5">Delete Campaign</Typography>
            <Typography>Campaign will be permanently deleted.</Typography>
            <Stack spacing={2} direction="row">
              <Button
                variant="contained"
                sx={{
                  backgroundColor: 'gray',
                  '&:hover': {
                    backgroundColor: 'gray',
                  },
                }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <LoadingButton variant="contained" color="error" onClick={handleDelete} loading={loading}>
                Delete
              </LoadingButton>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}

ConfirmDeleteModal.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
  }),
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setReload: PropTypes.func,
};
